import Vue from 'vue';

Vue.config.errorHandler = function (err, vm, info) {
  if (process.env.NODE_ENV === 'production') {
    Vue.nextTick(() => {
      try {
        // if (store.getters.token) {
          //
          //   ~Log({
          //     description: err.message,
          //     errorMessage: vm.$vnode.tag + '' + ' error in ' + (info + ''),
          //     url: window.location.href,
          //     errorStack: err.stack,
          //     queryString:
          //       window.location.href && window.location.href.indexOf('?') > 0
          //         ? window.location.href.substring(window.location.href.indexOf('?'))
          //         : '',
          //   })
          //   .then(
          //     results => { },
          //     error => { }
          //   );
        // }
      } catch (error) {
        console.error(error);
      }
    });
  } else {
    console.error(err);
  }

};
